import { defineWave } from '../schema';

/** BLOC C2 — la crête. Le pic d'intensité du monde 1.
 *
 *  Faucheurs et Rôdeurs ensemble : une menace qui poursuit ET une menace qui
 *  interdit, en même temps. C'est la combinaison que le joueur doit avoir
 *  apprise à traiter séparément dans les blocs précédents.
 *
 *  Rien de nouveau n'est introduit ici — un pic d'intensité n'est pas le moment
 *  d'enseigner quoi que ce soit. */
export default defineWave({
  id: 'c2-crete',
  duration: 18,
  spawns: [
    { at: 0.0, enemy: 'rodeur', lane: 2, count: 1, spacing: 0 },
    { at: 0.3, enemy: 'rodeur', lane: 4, count: 1, spacing: 0 },
    { at: 1.5, enemy: 'faucheur', lane: 3, count: 1, spacing: 0 },
    { at: 4.0, enemy: 'mite', lane: 1, count: 6, spacing: 0.06 },
    { at: 4.3, enemy: 'mite', lane: 5, count: 6, spacing: 0.06 },
    { at: 6.5, enemy: 'faucheur', lane: 1, count: 1, spacing: 0 },
    { at: 6.9, enemy: 'faucheur', lane: 5, count: 1, spacing: 0 },
    { at: 9.5, enemy: 'eclat', lane: 3, count: 5, spacing: 0.45 },
    { at: 12.0, enemy: 'rodeur', lane: 3, count: 1, spacing: 0 },
    { at: 13.5, enemy: 'faucheur', lane: 2, count: 1, spacing: 0 },
    { at: 13.9, enemy: 'faucheur', lane: 4, count: 1, spacing: 0 },
    { at: 16.0, enemy: 'mite', lane: 3, count: 10, spacing: 0.05 },
  ],
});
